import type { Cita } from '../types';

function textoFechaParaMensaje(fechaIso: string): string {
  const fecha = new Date(fechaIso + 'T00:00:00');
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  if (fecha.getTime() === hoy.getTime()) return 'hoy';

  return (
    'el ' +
    fecha.toLocaleDateString('es-MX', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    })
  );
}

function plantillaMensaje(cita: Cita): string {
  return `Hola ${cita.cliente}, te recordamos tu cita ${textoFechaParaMensaje(cita.fecha)} a las ${cita.hora} en Tokyo Planet. Si necesitas hacer algún cambio en tu cita, comunícate con nosotros. ¡Te esperamos!`;
}

export function enviarWhatsApp(cita: Cita): void {
  if (!cita.telefono) {
    alert('Este cliente no tiene teléfono registrado');
    return;
  }

  let telefono = cita.telefono.replace(/\D/g, '');
  if (!telefono.startsWith('52')) {
    telefono = '52' + telefono;
  }

  const url = `https://wa.me/${telefono}?text=${encodeURIComponent(plantillaMensaje(cita))}`;
  window.open(url, '_blank');
}

export function enviarSMS(cita: Cita): void {
  if (!cita.telefono) {
    alert('Este cliente no tiene teléfono registrado');
    return;
  }

  const url = `sms:${cita.telefono}?body=${encodeURIComponent(plantillaMensaje(cita))}`;
  window.location.href = url;
}
